var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"text-transform":"uppercase","margin-bottom":"0px","font-size":"12px"}},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticStyle:{"color":"black","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }